import { createStore, createEvent } from 'effector';
import { LocalStorageUtils } from '@shared/utils';

const setDarkModeEvent = createEvent<boolean>();
const toggleDarkModeEvent = createEvent();
const clearEvent = createEvent();

const $store = createStore<boolean>(LocalStorageUtils.getThemeIsDark())
  .on(setDarkModeEvent, (_, data) => data)
  .on(toggleDarkModeEvent, (prev) => !prev)
  .reset(clearEvent);

$store.watch((isDark) => {
  if (isDark) {
    document.documentElement.className = 'dark';
    document.documentElement.setAttribute('data-mode', 'dark');
  } else {
    document.documentElement.className = '';
    document.documentElement.setAttribute('data-mode', 'light');
  }
  LocalStorageUtils.setThemeIsDark(isDark);
});

export const $themeStore = {
  store: $store,
  events: {
    setDarkMode: setDarkModeEvent,
    toggleDarkMode: toggleDarkModeEvent,
    clear: clearEvent,
  },
};
